import React, { FC } from 'react';
import classNames from 'classnames';
type Props = {
  className?: string;
};
const NewTag: FC<Props> = props => {
  const { className } = props;
  return (
    <div
      className={classNames(
        'absolute w-[25px] h-3.5 leading-[14px] text-xs text-center text-reserved-true-white font-medium rounded-[3px] right-0 top-0 bg-surface-100-bg',
        className
      )}>
      <div className="w-full h-full whitespace-nowrap scale-[0.7]">New</div>
    </div>
  );
};
export default NewTag;
